<ul id="app-periodical-grid-container" class="app-periodical-grid-layout-wrapper">
  <li *ngFor="let item of periodicalService.items">
    <app-periodical-grid-item [selectable]="periodicalService.adminSelection" [container]="container" [item]="item"></app-periodical-grid-item>
  </li>
</ul>